var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import { withFormik, Form } from 'formik';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { InputField } from './Ui/InputField/InputField';
import { SelectField } from './Ui/SelectField/SelectField';
import { FormNavigation } from './Ui/FormNavigation/FormNavigation';
import { appConfigState, appCountriesState, appCustomerState, appOrderState, useProgress, } from '../Domain/State/AppState';
import { AppServiceContext } from '../Domain/Context/AppServiceContext';
import { useTrackPageWithCustomDimensions } from '../Tracking';
var AddressFormInner = function (props) {
    var isSubmitting = props.isSubmitting, errors = props.errors, submitButtonLabel = props.submitButtonLabel, handleBack = props.handleBack, handleChange = props.handleChange, initialValues = props.initialValues, setFieldValue = props.setFieldValue;
    var countries = useRecoilValue(appCountriesState);
    var trackingPrefix = useRecoilValue(appConfigState).trackingPrefix;
    return (_jsxs(Form, __assign({ id: "".concat(trackingPrefix, "-address-step") }, { children: [_jsx("fieldset", __assign({ className: "form-page" }, { children: _jsxs("div", __assign({ className: "fields row" }, { children: [_jsxs("div", __assign({ className: "field field--text col col-12 col-md-12" }, { children: [_jsx("label", { children: "Ansprechpartner in der Praxis" }), _jsx("div", { className: "field__text" })] })), _jsx(InputField, { label: "E-Mail", fieldName: "email", error: errors.email, handleChange: handleChange, initialValue: initialValues.email, isRequired: true }), _jsx(InputField, { label: "Vorname", fieldName: "firstName", error: errors.firstName, handleChange: handleChange, initialValue: initialValues.firstName, isRequired: true }), _jsx(InputField, { label: "Nachname", fieldName: "lastName", error: errors.lastName, handleChange: handleChange, initialValue: initialValues.lastName, isRequired: true }), _jsx(InputField, { label: "Telefon/Mobiltelefon", fieldName: "phoneNumber", error: errors.phoneNumber, handleChange: handleChange, initialValue: initialValues.phoneNumber }), _jsx(InputField, { label: "Unternehmen", fieldName: "company", error: errors.company, handleChange: handleChange, initialValue: initialValues.company }), _jsx(SelectField, { label: "Land", fieldName: "countryCode", error: errors.countryCode, options: countries, initialValue: initialValues.countryCode, setFieldValue: setFieldValue, isRequired: true }), _jsx(InputField, { label: "Stra\u00DFe", fieldName: "street", error: errors.street, handleChange: handleChange, initialValue: initialValues.street, isRequired: true }), _jsx(InputField, { label: "Stadt", fieldName: "city", error: errors.city, handleChange: handleChange, initialValue: initialValues.city, isRequired: true }), _jsx(InputField, { label: "PLZ", fieldName: "postcode", error: errors.postcode, handleChange: handleChange, initialValue: initialValues.postcode, isRequired: true })] })) })), _jsx("div", { children: _jsx("p", __assign({ className: "px-2 pt-3" }, { children: "Mit * markierte Felder sind Pflichtfelder" })) }), _jsx(FormNavigation, { submitCaption: submitButtonLabel, handleBack: handleBack, switching: isSubmitting })] })));
};
var AddressFormOuter = withFormik({
    mapPropsToValues: (function (props) { return props.formValues; }),
    validateOnChange: false,
    validateOnBlur: false,
    handleSubmit: function (values, formikBag) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, orderToken, orderService, orderUpdater, handleSubmit, isSwitching, setAdditionalCustomerData, errors, emailRegex, res, errorMessage;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = formikBag.props, orderToken = _a.orderToken, orderService = _a.orderService, orderUpdater = _a.orderUpdater, handleSubmit = _a.handleSubmit, isSwitching = _a.isSwitching, setAdditionalCustomerData = _a.setAdditionalCustomerData;
                    errors = {};
                    isSwitching(true);
                    emailRegex = /^([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]+|\\{\\D[A-Za-z0-9\\-]+\\})$/;
                    if (values.email === undefined || values.email === '' || !emailRegex.test(values.email)) {
                        errors.email = 'Es muss eine gültige E-Mail-Adresse angegeben werden.';
                        formikBag.setErrors(errors);
                        isSwitching(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, (orderService === null || orderService === void 0 ? void 0 : orderService.addAddress(orderToken, values, orderUpdater))];
                case 1:
                    res = _c.sent();
                    if (Object.prototype.hasOwnProperty.call(res, 'statusCode')) {
                        if ((res === null || res === void 0 ? void 0 : res.statusCode) !== 200) {
                            errorMessage = res.message;
                            formikBag.setSubmitting(false);
                            // @ts-ignore
                            (_b = errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.violations) === null || _b === void 0 ? void 0 : _b.forEach(function (_a) {
                                var propertyPath = _a.propertyPath, message = _a.message;
                                var key = propertyPath.replace('billingAddress.', '');
                                if (key && key !== '') {
                                    errors[key] = message;
                                }
                            });
                            formikBag.setErrors(errors);
                            isSwitching(false);
                            return [2 /*return*/];
                        }
                    }
                    setAdditionalCustomerData({
                        customerEmail: values.email,
                        customerPhoneNumber: values.phoneNumber,
                        company: values.company,
                    });
                    handleSubmit();
                    return [2 /*return*/];
            }
        });
    }); },
    enableReinitialize: true,
})(AddressFormInner);
export function Address() {
    var _a = useState({
        email: '',
        firstName: '',
        lastName: '',
        phoneNumber: '',
        company: '',
        countryCode: '',
        street: '',
        city: '',
        postcode: '',
    }), formValues = _a[0], setFormValues = _a[1];
    var _b = useContext(AppServiceContext) || {}, shopService = _b.shopService, orderService = _b.orderService;
    var _c = useRecoilState(appCountriesState), countries = _c[0], setCountries = _c[1];
    var _d = useRecoilState(appOrderState), order = _d[0], setOrder = _d[1];
    var _e = useProgress(), stepForward = _e.stepForward, stepBackward = _e.stepBackward, setSwitching = _e.setSwitching;
    var _f = useRecoilState(appCustomerState), _g = _f[0], customerEmail = _g.customerEmail, customerPhoneNumber = _g.customerPhoneNumber, company = _g.company, setCustomer = _f[1];
    var pushInstruction = useMatomo().pushInstruction;
    var trackingPrefix = useRecoilValue(appConfigState).trackingPrefix;
    useEffect(function () {
        setSwitching(false);
    }, []);
    useEffect(function () {
        if (!shopService) {
            return;
        }
        shopService
            .getCountries()
            .then(function (countryResources) {
            setCountries(countryResources);
        });
        var address = order === null || order === void 0 ? void 0 : order.billingAddress;
        setFormValues({
            email: customerEmail !== null && customerEmail !== void 0 ? customerEmail : '',
            firstName: (address === null || address === void 0 ? void 0 : address.firstName) || '',
            lastName: (address === null || address === void 0 ? void 0 : address.lastName) || '',
            phoneNumber: customerPhoneNumber !== null && customerPhoneNumber !== void 0 ? customerPhoneNumber : '',
            company: company !== null && company !== void 0 ? company : '',
            countryCode: (address === null || address === void 0 ? void 0 : address.countryCode) || '',
            street: (address === null || address === void 0 ? void 0 : address.street) || '',
            city: (address === null || address === void 0 ? void 0 : address.city) || '',
            postcode: (address === null || address === void 0 ? void 0 : address.postcode) || '',
        });
    }, [order]);
    var handleSubmit = function () {
        var form = document.getElementById("".concat(trackingPrefix, "-address-step"));
        pushInstruction('FormAnalytics::trackFormSubmit', form);
        stepForward();
    };
    useEffect(function () {
        setTimeout(function () {
            var form = document.getElementById("".concat(trackingPrefix, "-address-step"));
            if (form) {
                pushInstruction('FormAnalytics::trackForm', form);
            }
        }, 500);
    }, []);
    useTrackPageWithCustomDimensions();
    return (_jsx(_Fragment, { children: orderService && (order === null || order === void 0 ? void 0 : order.tokenValue)
            && _jsx(AddressFormOuter, { orderToken: order === null || order === void 0 ? void 0 : order.tokenValue, orderService: orderService, orderUpdater: setOrder, countries: countries, handleSubmit: handleSubmit, isSwitching: setSwitching, submitButtonLabel: 'Weiter', setAdditionalCustomerData: setCustomer, handleBack: stepBackward, formValues: formValues }) }));
}
